import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import AppSidebarV2 from "../components/layout/AppSidebarV2";
import PsychologistTestsPanel from "../components/dashboard/PsychologistTestsPanel";
import { useAuth } from "../auth/authStore";
import { useNotifications } from "../notifications/notificationsStore";

function firstName(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)[0] || "коллега";
}

export default function PsychologistTests() {
  const navigate = useNavigate();
  const { me, logout } = useAuth();
  const { unreadNotificationsCount = 0 } = useNotifications();

  const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);

  const userName = me?.name || me?.fullName || me?.login || me?.email || "Психолог";
  const greetingDate = React.useMemo(() => {
    return new Intl.DateTimeFormat("ru-RU", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date());
  }, []);

  const handleLogout = React.useCallback(async () => {
    await logout();
    navigate("/login", { replace: true });
  }, [logout, navigate]);

  return (
    <div className="psych-dashboard-v2 client-dashboard-v2 podcasts-hub">
      <Helmet prioritizeSeoTags>
        <title>Тесты психолога | Бюро Души</title>
        <meta
          name="description"
          content="Рабочий экран управления тестами психолога: список тестов, статусы публикации и назначения клиентам."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="shell shell--shared podcasts-shell">
        <AppSidebarV2
          activeKey="dashboard"
          mobileOpen={mobileSidebarOpen}
          onCloseMobile={() => setMobileSidebarOpen(false)}
          userName={userName}
          roleLabel="Психолог"
          canOpenLiteratureEditor
          notificationsBadge={unreadNotificationsCount}
          onLogout={handleLogout}
        />

        <button
          className={`podcasts-overlay ${mobileSidebarOpen ? "is-open" : ""}`}
          type="button"
          onClick={() => setMobileSidebarOpen(false)}
          aria-label="Закрыть меню"
        />

        <main className="main podcasts-main cd-main">
          <div className="topbar">
            <div className="topbar-left">
              <button type="button" className="btn-icon topbar-hamburger" onClick={() => setMobileSidebarOpen(true)} aria-label="Открыть меню">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
              <div>
                <div className="topbar-greeting">Тесты психолога, {firstName(userName)} 👋</div>
                <div className="topbar-date">{greetingDate}</div>
              </div>
            </div>

            <div className="topbar-right">
              <button type="button" className="btn-sm" onClick={() => navigate("/dashboard")}>
                В кабинет
              </button>
              <button type="button" className="btn-sm primary" onClick={() => navigate("/chat")}>
                Открыть чат
              </button>
            </div>
          </div>

          <div className="page">
            <PsychologistTestsPanel />
          </div>
        </main>
      </div>
    </div>
  );
}
